"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getHostingApp: ()=>getHostingApp,
    getHostName: ()=>getHostName
});
const products_js_namespaceObject = require("../constants/products.js");
const getHostingApp = (viewTypeOrPath)=>{
    if (viewTypeOrPath && Object.values(products_js_namespaceObject.appNameMap).some((types)=>types[0] === viewTypeOrPath)) return viewTypeOrPath;
    if ('undefined' == typeof window) return;
    const pathname = 'string' == typeof viewTypeOrPath ? viewTypeOrPath : window?.location?.pathname ?? '/';
    if ('/' === pathname || pathname.startsWith('/home') || pathname.startsWith('/hotels') || pathname.startsWith('/flights') || pathname.startsWith('/vacationpackages') || pathname.startsWith('/vip')) return products_js_namespaceObject.appNameMap["next-landing"]["0"];
    if (pathname.startsWith('/relax')) return pathname.includes('/at/') ? products_js_namespaceObject.appNameMap["relax-at"]["0"] : products_js_namespaceObject.appNameMap.relax["0"];
    if (pathname.startsWith('/m/fly/search')) return products_js_namespaceObject.appNameMap["fly-search"]["0"];
    if (pathname.startsWith('/drive/landing') || pathname.startsWith('/rentalcars') || pathname.startsWith('/car-rentals') || pathname.startsWith('/rental-cars') || pathname.startsWith('/drive/search/r')) return products_js_namespaceObject.appNameMap["drive-search-responsive"]["0"];
    if (pathname.startsWith('/cart/checkout')) return products_js_namespaceObject.appNameMap["cart-checkout"]["0"];
    if (pathname.startsWith('/travel-itinerary')) return products_js_namespaceObject.appNameMap["travel-itinerary"]["0"];
};
const getHostName = (IS_STORYBOOK, IS_CHROMATIC)=>{
    if ('undefined' == typeof window) return;
    let hostname = IS_STORYBOOK ? 'localhost:8080' : window?.location?.hostname ?? 'www.priceline.com';
    hostname = IS_CHROMATIC ? 'www.priceline.com' : hostname;
    const protocol = window?.location?.protocol ?? 'https:';
    return -1 !== hostname.indexOf('localhost') ? 'http://localhost:8080' : `${protocol}//${hostname}`;
};
exports.getHostName = __webpack_exports__.getHostName;
exports.getHostingApp = __webpack_exports__.getHostingApp;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getHostName",
    "getHostingApp"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
